// 小狗留言气泡（EP-007-S4 / GDD 02 §②-2.7）。
// 文案来源 design/ux/04-dog-notes.md，按 noteId 索引（共 10 条）；每条 ≤20 字，
// 第一人称、无感叹号、不剧透礼物名、无阿拉伯数字（B1）。
// 气泡高度自适应（无 height / 无绝对定位），不会压到礼物与 CTA。
// （v2：明信片不再作礼物，postcard-window-lights / postcard-legs-turn-home 两条配文已从本字典移除；
// 新明信片配文 12 条 ≤25 字在 src/runtime/postcardNotes.ts，由 src/domain/travel/postcardRoll.ts 触发。）
// 🆕 P6-POLISH-ENG-002：noteId 现在可能来自两个互不相干的池 —— DOG_NOTES（带礼物，10 条）
//   与 EMPTY_HANDS_NOTES（空手，16 条）。两套池**不混用**，各自只在对应分支出现；
//   本组件两者都查（先带礼物池，再空手池），保证 RevealSequence 不需要区分。
import { DOG_NOTES, EMPTY_HANDS_NOTES } from '../runtime/sequencer';

interface NoteBubbleProps {
  noteId: string;
}

export function NoteBubble({ noteId }: NoteBubbleProps) {
  const text = DOG_NOTES[noteId] ?? EMPTY_HANDS_NOTES[noteId] ?? '';
  return (
    <div className="note-bubble" role="note" aria-label={text}>
      {text}
    </div>
  );
}
